import Vue from 'vue';

/**
 * List of default filters to be
 * imported into the project globally
 *
 * @type {object}
 */
export const defaultFilters = {};

/**
 * Load global Vue Filters
 * usage: {{ value | filterName }} e.g. {{ price | currencyFormat }}
 */
export function loader() {
    Object.keys(defaultFilters).forEach((filter) => {
        Vue.filter(filter, defaultFilters[filter]);
    });
}
